export default "__VITE_ASSET__DWUjpcC4__"